import AppointmentStatusDayCard from './AppointmentStatusDayCard';

export default AppointmentStatusDayCard;
